import React from 'react';

/**
 * Search icon SVG
 */
const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8"/>
    <path d="m21 21-4.35-4.35"/>
  </svg>
);

/**
 * SearchInput Component
 * 
 * Search input for filtering/creating tags.
 */
const SearchInput = ({
  inputRef,
  value,
  onChange,
  onKeyDown,
  hasSelectedTags,
}) => {
  return (
    <div className="tags-picker__search-area">
      <div className="tags-picker__search-icon">
        <SearchIcon />
      </div>
      <input
        ref={inputRef}
        type="text"
        className="tags-picker__search-input"
        placeholder={hasSelectedTags ? "Add another tag..." : "Search or create tag..."}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

export default SearchInput;

